// @unocss-include
import { useId } from 'react';
export function useIdOrGenerated(id) {
    const generated = useId();
    return id || generated;
}
//# sourceMappingURL=useIdOrGenerated.js.map